import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'caretLeftSmall',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-caret-left-small wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="m8.134 12.288 6.538-4.235c.178-.115.328-.038.328.176v8.542c0 .21-.147.292-.328.176l-6.538-4.235c-.177-.115-.18-.307 0-.424Z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-caret-left-small.svg',
    category: 'Core',
    tags: ['navigation', 'arrow', 'triangle', 'data', 'table', 'grid'],
};
export default icon;
